import React, { Component } from "react";
import { Card, CardBody, Form, InputGroup } from "reactstrap";
import Flatpickr from "react-flatpickr";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import { getCurrentDay } from "../../helpers/utils";
import CustomMultipleDateRange from "../../components/CustomMultipleDateRange/CustomMultipleDateRange";
import { AvForm } from "availity-reactstrap-validation";

class DynamicFormMultipleFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        ad_ids: this.props.data.ad_ids,
        campaign_ids: this.props.data.ad_ids,
        campaign_names: this.props.data.campaign_names,
      });
    }
  }

  handleSelect = (data, i, filterType) => {
    const { date } = this.state;
    let dataCheck = data || [];
    this.props.onFilterSelect(dataCheck, i);
  };

  onlyMonthFilterChange = (date, key) => {
    this.setState({ date });
    let currentDate = new Date(date.value);
    let firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
      12
    );
    let lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0,
      12
    );

    const data = {
      start_date: new Date(firstDay).toJSON().split("T")[0],
      end_date: new Date(lastDay).toJSON().split("T")[0],
    };

    this.props.onFiltersChange(data, key);
  };

  onFiltersChange = (date, key) => {
    this.setState({ date });

    const data = {
      start_date: date.start_date,
      end_date: date.end_date || getCurrentDay(),
    };

    if (date.end_date !== undefined) {
      this.props.onFiltersChange(data, key);
    }
  };

  handleSelectedOffers = (_, status, data) => {
    const { offerTypes } = this.state;

    let dt = offerTypes.concat([]);

    for (let i in dt) {
      dt[i].checked = data.find(x => x.value == dt[i].id) !== undefined;
    }

    this.setState({
      offerTypes: dt,
    });

    this.handleFiltering();
  };

  render() {
    return (
      <StyledRow style={{ ...this.props.rowStyle }}>
        <div className="col-12">
          <StyledCard
            style={{
              marginBottom: this.props.activePlug ? "-12px" : "",
              borderBottom: this.props.activePlug ? "1.2px solid #f1f1f1" : "",
              bottom: this.props.activePlug ? "26px" : "",
            }}
          >
            <CardBody
              style={{
                padding: "1.25rem 0",
                background: "white",
                ...this.props.style,
              }}
            >
              <FilterContainer className="d-flex justify-content-between align-items-end">
                <div>
                  <Form className="row gy-2 gx-3 align-items-center">
                    {this.props.activePlug && (
                      <h4
                        style={{
                          textTransform: "uppercase",
                          fontWeight: 600,
                        }}
                        className="font-size-16"
                      >
                        {this.props.plugText}
                      </h4>
                    )}
                    {this.props.filtersFields && (
                      <div className="col-sm-auto">
                        {!this.props.NoFilterBy && (
                          <span>{this.props.filterTitle || "Filter by"}:</span>
                        )}
                      </div>
                    )}
                    {this.props.filtersFields &&
                      this.props.filtersFields.map((i, key) => (
                        <div className="col-sm-auto" key={key}>
                          <DefaultMultipleSelect
                            options={
                              i.filterData?.length > 0
                                ? i.filterData.map((i, idx) => ({
                                    key: i.value,
                                    text: i.label,
                                    checked: false,
                                  }))
                                : []
                            }
                            search
                            filtered_by={this.props.filtered_by[key]}
                            filtered_params={this.props.filtered_params}
                            onChange={data =>
                              this.handleSelect(data, i, i.filterType || null)
                            }
                            plug={i.plug}
                            isLoading={i.loading || false}
                          />
                        </div>
                      ))}
                  </Form>
                  {this.props.childrenBreadCrumbs && (
                    <div style={{ margin: "0 0 10px 0" }}>
                      {this.props.children}
                    </div>
                  )}
                </div>
                <div>
                  <div
                    className={`gy-2 gx-3 align-items-center d-flex gap-3 float-end`}
                  >
                    {this.props.dateFilters?.map((i, idx) => (
                      <PickerStyled key={i.key}>
                        {i.isTitle !== false && <p>{i.plug}:</p>}
                        <AvForm>
                          {this.props.onlyMonth ? (
                            <CustomMultipleDateRange
                              value={i.value}
                              className="form-control d-block"
                              placeholder="Select date..."
                              name={`date-range-picker-${idx}-${this.props.name}`}
                              defaultValue={getCurrentDay}
                              datePickerType={"calendar-with-static"}
                              errorText="Date is required!"
                              customStyle={{
                                top: "55px",
                              }}
                              onChange={date =>
                                this.onlyMonthFilterChange(date, i.key)
                              }
                              monthTextFormat
                            />
                          ) : (
                            <CustomMultipleDateRange
                              value={i.value}
                              className="form-control d-block"
                              placeholder={`Select ${i.plug}...`}
                              name={`date-range-picker-${idx}-${this.props.name}`}
                              datePickerType="round"
                              onChange={date =>
                                this.onFiltersChange(date, i.key)
                              }
                            />
                          )}
                        </AvForm>
                      </PickerStyled>
                    ))}
                  </div>
                </div>
              </FilterContainer>
            </CardBody>
          </StyledCard>
        </div>
      </StyledRow>
    );
  }
}

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 100;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  max-width: 220px;
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    font-size: 12px;
    background: #fff !important;
  }
`;

DynamicFormMultipleFilter.defaultProps = {
  NoFilterBy: false,
  activePlug: false,
  childrenBreadCrumbs: false,
  name: "Name...",
  onlyMonth: false,
};

DynamicFormMultipleFilter.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  data: PropTypes.any,
  filtersFields: PropTypes.any,
  selectedDate: PropTypes.any,
  dateFilters: PropTypes.array,
  onFilterSelect: PropTypes.func,
  style: PropTypes.object,
  filterTitle: PropTypes.any,
  filtered_params: PropTypes.object,
  filtered_by: PropTypes.array,
  NoFilterBy: PropTypes.bool,
  name: PropTypes.string,
  activePlug: PropTypes.bool,
  childrenBreadCrumbs: PropTypes.bool,
  plugText: PropTypes.string,
  rowStyle: PropTypes.object,
  children: PropTypes.any,
  onlyMonth: PropTypes.bool,
};

export default DynamicFormMultipleFilter;
